export default "__VITE_ASSET__DccbIG7x__"